import { render } from "./product-title.vue?vue&type=template&id=0f8086ad"
import script from "./product-title.vue?vue&type=script&lang=js"
export * from "./product-title.vue?vue&type=script&lang=js"

import "./product-title.vue?vue&type=style&index=0&id=0f8086ad&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__